module.exports = (__webpack_require__(11))(70);


//////////////////
// WEBPACK FOOTER
// delegated ../../node_modules/raven-js/src/singleton.js from dll-reference vendor_lib
// module id = 460
// module chunks = 0